import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ErrorMessageStyles";

export default class ErrorMessage extends Component {
  render() {
    return (
      <div className={css(styles.bannerWrapper)}>
        <span className={css(styles.banner)}>{this.props.message}</span>
      </div>
    );
  }
}
